var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimmerSwitches({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.29,13.71c-1.2,0-2.17-0.97-2.17-2.17s0.97-2.17,2.17-2.17s2.17,0.97,2.17,2.17S4.48,13.71,3.29,13.71z  M3.29,9.86c-0.92,0-1.67,0.75-1.67,1.67s0.75,1.67,1.67,1.67s1.67-0.75,1.67-1.67S4.21,9.86,3.29,9.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4.73,10.19 4.29,9.95 8.38,2.42 8.82,2.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.05,8.44c-0.21,0-0.4-0.15-0.43-0.37C2.6,7.96,2.62,7.84,2.69,7.75c0.07-0.09,0.17-0.16,0.28-0.18 l11.91-4.58v5.45H3.09C3.08,8.44,3.06,8.44,3.05,8.44z M3.39,7.94h10.99V3.71L3.39,7.94z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimmerSwitches);
export default __webpack_public_path__ + "static/media/DimmerSwitches.b9f7e1ae17450c5d4e2ba46daaef99a2.svg";
export { ForwardRef as ReactComponent };